import { autoGenerateHref } from '../../api/ContentUtil';
import { withRouter } from 'react-router';
import constants from '../../common/constants';
import { withAppContext } from '../../contexts/AppContext';
import PublicationViewer from './PublicationViewer';

class AuthorFinalizingViewer extends PublicationViewer {
  protected showComment = false;
  protected showContentAbstract = false;
  protected allowedEditing = false;
  protected hideEmptySections = false;
  protected isFinalizing = true;
  protected showLastBarRaiserEvaluation: boolean = true;

  // @ts-expect-error TS2416 - strict migration
  protected reloadData = async () => {
    const { contentId, workflowId, finalizerId } = this.props.match.params;
    const parsedWorkflowId = parseInt(workflowId, constants.DECIMAL);

    this.setState({
      isLoading: true,
    });

    const { workflow } = await this.mplServiceClient.getContentWorkflow(contentId);

    const classifier = `finalizing/${finalizerId}`;
    const publication = await this.mplServiceClient.getPublicationByWorkflow(
      contentId,
      parsedWorkflowId,
      classifier,
    );

    const sharedWith = await this.mplServiceClient.listContentSharedWith(workflow.contentId);

    // Current draft author and co-authors should see sectional comments
    const currentUserId = this.props.appContext.authnInfo?.userProfile.userId;
    const showSectionalComments =
      currentUserId &&
      (workflow.ownerId === currentUserId ||
        sharedWith.accessUsers.some((u) => u.userId === currentUserId));

    // Auto generate href for each content node if they are not existed.
    autoGenerateHref(publication.content.contentData, publication.content?.contentMetadata);

    this.setState({
      isLoading: false,
      publication,
      // @ts-expect-error TS2322 - strict migration
      showSectionalComments,
      workflow,
      workflowId: parsedWorkflowId,
    });
  };
}

export default withRouter(withAppContext(AuthorFinalizingViewer));
